import React from "react";
import { useDispatch, useSelector } from "react-redux";

import ChartActions from "store/actions/charts";
import { getFetchTagsPayload } from "store/thunk/charts";

import ChartAPIs from "api/chart";

import { getFiltersPayload } from "utils/utils";
import { CHART_HEADER_ACTIONS } from "constants/chartConstant";

import DataDownloadDialog from "components/DataDownloadDialog";

import FileDownloadHandler from "./dataDownloadHandler";

import "./index.scss";

const ChartDownloadData = () => {
  const dispatch = useDispatch();
  const { chartData } = useSelector(state => state);

  const getDataPayload = group => {
    const { Tags } = chartData;
    const { DurationRanges } = chartData;
    return getFetchTagsPayload(Tags, DurationRanges, group);
  };

  const downloadNewData = async (group, downloadDurationMsg) => {
    let payload = getDataPayload(group);
    const baseline = chartData.NormalizedTags.length ? chartData.NormalizationFilters.Baseline : null;
    if (baseline) {
      const normalizeFilters = getFiltersPayload(chartData.NormalizationFilters);
      payload = { ...payload, ...normalizeFilters };
    }
    FileDownloadHandler.fetchAndDownloadTagsData(chartData.Tags, ChartAPIs.getChartTimeSeriesData, payload, baseline, downloadDurationMsg);
  };

  const downloadPlottedData = downloadDurationMsg => {
    const { Tags, PlotData, OrigPlotData } = chartData;
    const dataToDownload = OrigPlotData || PlotData;
    if (dataToDownload && Tags) {
      FileDownloadHandler.downloadChartData(Tags, dataToDownload, downloadDurationMsg);
    }
  };

  const onDialogClose = (data, downloadDurationMsg) => {
    if (data) {
      if (data.interval) {
        downloadNewData(data.interval, downloadDurationMsg);
      } else {
        downloadPlottedData(downloadDurationMsg);
      }
    }
    dispatch(ChartActions.setEditCurrentView(CHART_HEADER_ACTIONS.NONE));
  };

  return <DataDownloadDialog DurationRanges={chartData.DurationRanges} onDialogClose={onDialogClose} />;
};

export default ChartDownloadData;
